import type {MatchMode} from '@wandb/weave/common/util/columnMatching';
import React, {useState} from 'react';

import type * as RunFeed from '../../../util/runfeed';
import TableEditorBase from './TableEditorBase';

interface WBTableColumnEditorProps {
  config: RunFeed.Config;
  allColumns: string[];
  fixedColumns?: string[];
  objectType?: string; // Just a string used in the UI. defaults to Columns, but is Parameters in the parameter importance panel

  update(config: RunFeed.Config): void;
}

const ParameterImportanceTableEditor = (props: WBTableColumnEditorProps) => {
  const [search, setSearch] = useState('');
  const [searchMode, setMatchMode] = useState<MatchMode>('fuzzy');

  return (
    <TableEditorBase
      config={props.config}
      allColumns={props.allColumns}
      fixedColumns={props.fixedColumns}
      searchQuery={search}
      setSearch={setSearch}
      searchMode={searchMode}
      setMatchMode={setMatchMode}
      update={props.update}
      objectType={props.objectType}
    />
  );
};

export default ParameterImportanceTableEditor;
